module.exports = __webpack_public_path__ + "img/logo.d85926e7.png";